import { render } from "./mailRed.vue?vue&type=template&id=08e135b7"
import script from "./mailRed.vue?vue&type=script&lang=js"
export * from "./mailRed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__